import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from 'features/auth/authSlice';

export default function RequireAuth() {
  const location = useLocation();
  const user = useSelector(selectUser);

  return user ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
}
